// @ts-nocheck
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { RefObject, useEffect } from "react";

const useDynamicSearchWidth = (
    mainRef: RefObject<HTMLDivElement | null>,
    logoRef: RefObject<HTMLDivElement | null>,
) => {
    const bunzlDispatch = useBunzlDispatch();

    useEffect(() => {
        const handleWindowResize = () => {
            const mainRefWidth = mainRef.current?.clientWidth || 0;
            const logoRefWidth = logoRef.current?.clientWidth || 0;
            const searchWidth = mainRefWidth - logoRefWidth - logoRefWidth;

            if (searchWidth) {
                bunzlDispatch({
                    type: "Pages/Header/SetSearchWidth",
                    primaryWidth: searchWidth,
                    loggedInOffset: 0,
                });
            }
        };

        handleWindowResize();

        window.addEventListener("resize", handleWindowResize);

        return () => window.removeEventListener("resize", handleWindowResize);
    }, [mainRef, logoRef, bunzlDispatch]);
};

export default useDynamicSearchWidth;
